<section class="cmn-innerpage-wrapper client-details">
  <div class="head">
    <div class="search-wrapper">
      <input
        type="text"
        class="cmn-header-search"
        placeholder="Search"
        (input)="onSearch($event)"
      />
    </div>
    <button class="cmn-add-btn" (click)="navigateTo('/customers/customer-new')">
      <img src="assets/images/icons/icon-add.svg" alt="Add icon" /> Add Customer
    </button>
  </div>
  <div class="sub-head">
    <ul>
      <li class="main">All Customers</li>
      <li class="edit" (click)="onEdit()">
        <img src="assets/images/icons/icon-edit-accounts.svg" alt="Edit Icon" />
        Edit
      </li>
      <!-- <li class="edit"><img src="assets/images/icons/icon-export-accounts.svg" alt="Export Icon"> Export</li> -->
      <!-- <li class="edit" (click)="toggleAttachFile($event)">
        <img src="assets/images/icons/icon-attach.svg" alt="Attach" />{{
          partnerDetails?.partner?.documents?.length
        }}
      </li> -->
    </ul>
    <!-- Comments Dropdown -->
    <div
      [ngClass]="{ show: isDropdownOpen }"
      class="common-dropdown filter-position"
      #dropdown
    >
      <button class="close-dropdown" (click)="toggleDropdown($event)"></button>
      <form [formGroup]="commentForm" (ngSubmit)="onComment()">
        <h6 class="cmn-popup-heading">Comments</h6>
        <div class="filter-inner-content">
          <div class="form-wrapper">
            <mat-form-field>
              <textarea
                matInput
                placeholder="Add Your Comment Here..."
                formControlName="comments"
              ></textarea>
            </mat-form-field>
          </div>
          <div class="btn-wrapper">
            <button class="cmn-apply-btn" type="submit">Comment</button>
          </div>
          <div class="timelinne-wrapper">
            <!-- ngFor -->
            <div class="timeline-box" *ngFor="let comment of comments">
              <div class="timeline-head">
                <ul>
                  <li>{{ comment?.employee?.firstName || "--" }}</li>
                  <li>{{ comment?.createdAt | date : "dd/MM/YYYY" }}</li>
                </ul>
                <h3>{{ comment?.createdAt | date : "hh:mm a" }}</h3>
              </div>
              <div class="timeline-content">
                <h4>{{ comment?.note || "--" }}</h4>
              </div>
            </div>
            <!-- ngFor -->
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="manual-journal-details-tab-wrapper">
    <div class="tab-left">
      <div class="tab-box-main-wrapper">
        <button
          class="tab-custom-button"
          *ngFor="let customer of allCustomers; let i = index"
          [class.active]="selectedTabIndex === i"
          (click)="selectTab(i)"
        >
          <div class="inn-box">
            <h2>{{ customer?.firstName + " " + customer?.lastName }}</h2>
            <h6>{{ customer?.country }}</h6>
          </div>
        </button>
      </div>
    </div>
    <div class="manual-journal-details-content-wrapper">
      <div>
        <div class="common-noimage-tab-wrapper">
          <mat-tab-group animationDuration="0ms">
            <!-- Mat Tab One -->
            <mat-tab>
              <ng-template mat-tab-label>
                <h2 class="leave-tab-title">Overview</h2>
              </ng-template>
              <div class="client-cmn-inner-content-wrapper">
                <app-overview></app-overview>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>
  </div>
</section>
